import { Formik } from 'formik'
import { ReactElement, useCallback } from 'react'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { Flexbox } from '../components/flexbox/flexbox'
import { UserId } from '../types/types'
import classNames from 'classnames'

interface FormErrors {
  newPassword?: string
  newPasswordCheck?: string
  oldPassword?: string
}

interface Props {
  userId?: UserId
}

const ChangePasswordForm = (props: Props): ReactElement | null => {
  const { userId } = props

  const onSubmit = useCallback(async (values, { setSubmitting }) => {
    setSubmitting(true)

    const { oldPassword, newPassword } = values
    await axios.put(getServerHost(`user/${userId}/password`), {
      oldPassword,
      newPassword,
    })

    setSubmitting(false)
  }, [])

  if (!userId) {
    return null
  }

  return (
    <Formik
      initialValues={{ oldPassword: '', newPassword: '', newPasswordAgain: '' }}
      validate={(values) => {
        const errors: FormErrors = {}
        if (!values.oldPassword) {
          errors.oldPassword = 'Required'
        }

        if (values.newPassword !== values.newPasswordCheck) {
          errors.newPasswordCheck = 'Passwords do not match'
          errors.newPassword = 'Passwords do not match'
        }

        if (!values.newPassword) {
          errors.newPassword = 'Required'
        }

        if (!values.newPasswordCheck) {
          errors.newPasswordCheck = 'Required'
        }

        return errors
      }}
      onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit} className="mt-8">
          {/* @ts-ignore */}
          <Flexbox isCol>
            <input
              type="password"
              name="oldPassword"
              onChange={handleChange}
              placeholder="Old password"
              onBlur={handleBlur}
              value={values.password}
              className="input input-bordered w-full min-w-8 mb-4"
            />
            <label className="label">
              <span className="label-text-alt text-error">
                {errors.oldPassword && touched.oldPassword && errors.oldPassword.toString()}
              </span>
            </label>

            <input
              type="password"
              name="newPassword"
              onChange={handleChange}
              placeholder="New password"
              onBlur={handleBlur}
              value={values.password}
              className="input input-bordered w-full min-w-8 mb-4"
            />
            <label className="label">
              <span className="label-text-alt text-error">
                {errors.newPassword && touched.newPassword && errors.newPassword.toString()}
              </span>
            </label>

            <input
              type="password"
              name="newPasswordCheck"
              onChange={handleChange}
              placeholder="New password again"
              onBlur={handleBlur}
              value={values.password}
              className="input input-bordered w-full min-w-8 mb-4"
            />
            <label className="label">
              <span className="label-text-alt text-error">
                {errors.newPasswordCheck &&
                  touched.newPasswordCheck &&
                  errors.newPasswordCheck.toString()}
              </span>
            </label>

            <button
              type="submit"
              className={classNames('btn w-full ', {
                'btn-disabled': isSubmitting,
              })}
              disabled={isSubmitting}>
              Submit
            </button>
          </Flexbox>
        </form>
      )}
    </Formik>
  )
}

export default ChangePasswordForm